<!-- 同步任务列表 -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">同步任务列表</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 0;">
		<div class="screen-box">
			<div class="screen-label">巨量推广账户</div>
			<a-select
				mode="multiple" 
				style="min-width: 240px;max-width: 600px;"
				placeholder="请选择广告账户"
				:filter-option="false"
				@change="handleChangeB"
				:getPopupContainer="getsPopupContainer" 
				@popupScroll="popupScrollCEshi" 
				showSearch
				allowClear
				@search="selectZhSearch"
				:not-found-content="s_fetching ? undefined : null" 
				@blur="zhBlur" 
				:value="jlSelectValue"
			  >
				<a-spin v-if="s_fetching" slot="notFoundContent" size="small" />
				<a-select-option v-for="(item,index) in selectGgData" :key="item.adv_id" :value="item.adv_id">
				  {{item.adv_name}}
				</a-select-option>
				<a-select-option v-if="loading_more_hint" value="-0-">
					<div style="color:rgb(98, 168, 234)">加载更多中...</div>
					
				</a-select-option>
			</a-select>
			
		</div>
		
		<div class="screen-box">
			<div class="screen-label">腾讯推广账户</div>
			<a-select
				mode="multiple" 
				style="min-width: 300px;max-width: 600px;"
				placeholder="请选择腾讯广告账户"
				:filter-option="false"
				@change="handleChangeC"
				:getPopupContainer="getsPopupContainer" 
				@popupScroll="popupScrollTxAcc" 
				showSearch
				allowClear
				@search="selectTxSearch"
				:not-found-content="t_fetching ? undefined : null" 
				@blur="txBlur" 
				:value="txSelectValue"
			  >
				<a-spin v-if="t_fetching" slot="notFoundContent" size="small" />
				<a-select-option v-for="(item,index) in selectTxGg" :key="item.account_id" :value="item.account_id">
				  {{item.account_name}}
				</a-select-option>
				<a-select-option v-if="t_loading_more_hint" value="-0-">
					<div style="color:rgb(98, 168, 234)">加载更多中...</div>
					
				</a-select-option>
			</a-select>
		</div>
		<div class="screen-box">
			<div class="screen-label">同步任务类型</div>
			<a-select
				show-search
				style="width: 220px"
				placeholder="请选择同步任务类型"
				@change="handleChangeT"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				allowClear
			  >
				<a-select-option v-for="(value,key) in syncTypeSelect" :key="key" :value="key" :title="value">
				  {{value}}
				</a-select-option>
			</a-select>
		</div>
		
		<a-button @click="searchButton('button')" :loading="search_button_loading" class="screen-box" type="primary" icon="search">搜索</a-button>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<!-- ID -->
			<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
				{{item.id}}
			</div>
			<!-- 平台类型 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
				{{item.platform_type | ptFilters}}
			</div>
			<!-- 推广账户ID -->
			<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
				{{item.adv_id}}
			</div>
			<!-- 同步任务类型 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
				{{item.type}}
			</div>
			<!-- 同步结果 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}" style="font-size: 12px;">
				<!-- {{item.task_result}} -->
				<div v-for="(value,key) in item.task_result" :key="key">
					<div>{{key}}： {{value.status}}</div>
				</div>
			</div>
			<!-- 创建人ID -->
			<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
				{{item.admin_id}}
			</div>
			<!-- 创建人 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
				{{item.admin_name}}
			</div>
			<!-- 创建时间 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[7].width + 'px'}">
				{{item.created_at}}
			</div>
			<!-- 更新时间 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[8].width + 'px'}">
				{{item.updated_at}}
			</div>
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>
	
	<!-- 分页 -->
	<!-- <div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;">
		<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" hideOnSinglePage />
	</div> -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { taskSyncList, logSelectUser, JLzhSelectGgzh, MPggSelectAcc, taskSyncPlatType } from '@/request/api'	
export default {
	name: 'taskSync_',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			filterList: {},
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:80, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"平台类型", width:100, type:"platform_type", },
				{title:"推广账户ID", width:180, type:"adv_id", },
				{title:"同步任务类型", width:180, type:"type", },
				{title:"同步结果", width:200, type:"task_result", },
				{title:"创建人ID", width:100, type:"admin_id", },
				{title:"创建人", width:120, type:"admin_name", },
				{title:"创建时间", width:180, type:"created_at", },
				{title:"更新时间", width:180, type:"updated_at", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			table_null_width: 1000,
			search_button_loading: false,
			
			r_page: 1, // 页数
			r_limit: 20, // 每页多少条
			table_total: 0, // 表格内容总数
			
			s_page: 1,
			s_limit: 100,
			selectGgData: [], // 选择广告账户
			s_adv_name: "", // 下拉选择框的搜索字段
			s_fetching: false, // 用于控制提示
			blurGgData: [], // 保存一份，用于失去焦点后，回复原来的数值
			loading_more_control: true, // 上拉加载更多控制
			loading_more_hint: false, // 上拉加载更多的提示
			
			r_advertiser_id: [], // 广告主账户16位id
			jlSelectValue: [], // 巨量账户下拉
			txSelectValue: [], // 腾讯账户下拉
			
			// 腾讯-广告账户下拉列表
			selectTxGg: [], // 选择广告账户
			blurTxGg: [], // 保存一份，用于失去焦点后，回复原来的数值
			t_page: 1,
			t_account_name: "", // 下拉选择框的搜索字段
			t_fetching: false, // 用于控制提示
			t_loading_more_control: true, // 上拉加载更多控制
			t_loading_more_hint: false, // 上拉加载更多的提示
			
			syncTypeSelect: {}, // 同步任务类型下拉
			r_platform_type: undefined,
		}
	},
	mounted() {
		let that = this
		that.search_button_loading = true
		
		// let nn = 0
		// that.rableTitle.forEach((res,index)=>{
		// 	nn = nn + res.width
		// })
		// that.table_scroll_width = nn + 30
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		// that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		// 获取搜索条件
		// logSelectUser().then(res=>{
		// 	console.log('获取搜索条件',res.data.data)
			
		// 	that.filterList = res.data.data.list
		// })
		
		// 巨量-广告账户
		JLzhSelectGgzh({
			page: 1,
			limit: that.s_limit,
		}).then(res=>{
			console.log('选择',res);
			that.selectGgData = res.data.data.data
			that.blurGgData = res.data.data.data
		})
		
		// 腾讯-广告账户下拉列表
		MPggSelectAcc({
			page: 1,
			limit: that.s_limit,
		}).then(res=>{
			console.log("广告账户下拉列表",res);
			
			that.selectTxGg = res.data.data.data
			that.blurTxGg = res.data.data.data
		})
		
		taskSyncPlatType({
			page: 1,
			limit: 1000,
		}).then(res=>{
			console.log("同步任务类型下拉",res);
			that.syncTypeSelect = res.data.data.list
		})
		
		that.searchButton()
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 投手
		
		// 巨量推广账户下拉
		handleChangeB(value){
			// 巨量与腾讯的推广账户下拉，不能同时选，一次只能选择一个
			if(this.txSelectValue.length == 0){
				this.jlSelectValue = value
			}
			else {
				this.$message.warning('巨量与腾讯的推广账户下拉，不能同时选择');
			}
		},
		// 腾讯推广账户下拉
		handleChangeC(value){
			// console.log(value);
			// 巨量与腾讯的推广账户下拉，不能同时选，一次只能选择一个
			if(this.jlSelectValue.length == 0){
				this.txSelectValue = value
			}
			else {
				this.$message.warning('巨量与腾讯的推广账户下拉，不能同时选择');
			}
		},
		// 同步任务类型下拉
		handleChangeT(e){
			console.log(e);
			this.r_platform_type = e
		},
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			if(type == 'button'){
				that.r_page = 1
			}
			
			let acc_id = []
			if(that.jlSelectValue.length > 0){
				acc_id = that.jlSelectValue
			}
			else if(that.txSelectValue.length > 0){
				acc_id = that.txSelectValue
			}
			
			taskSyncList({
				page: that.r_page,
				limit: that.r_limit,
				
				advertiser_id: acc_id,
				platform_type: that.r_platform_type,
			}).then(res=>{
				console.log("获取登录日志列表",res)
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// select选择器下拉加载更多功能实现
		popupScrollCEshi(e){ // 上拉触底加载更多
			// console.log(e.target.scrollHeight);
			// console.log(e.target.scrollTop);
			// console.log(e.target.scrollHeight - e.target.scrollTop);
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.loading_more_control){ // 节流，保证这期间只执行一次
					this.loading_more_hint = true
					this.loading_more_control = false
					let that = this
					that.s_page = that.s_page + 1
					console.log("上拉触底加载更多");
					JLzhSelectGgzh({
						page: that.s_page,
						limit: that.s_limit,
						adv_name: that.s_adv_name,
					}).then(res=>{
						console.log('选择',res);
						
						let data = that.selectGgData 
						that.loading_more_hint = false
						that.selectGgData = data.concat(res.data.data.data) 
						that.s_fetching = false
						that.loading_more_control = true
					})
				}
			}
		},
		// 选择框搜索-选择广告账户
		selectZhSearch(e){
			console.log("选择框搜索",e);
			let that = this
			that.selectGgData = []
			that.s_fetching = true
			that.s_adv_name = e
			
			JLzhSelectGgzh({
				page: 1,
				limit: that.s_limit,
				adv_name: e,
			}).then(res=>{
				console.log('选择',res);
				that.s_page = 1
				that.selectGgData = res.data.data.data
				that.s_fetching = false
			})
		},
		// 失去焦点
		zhBlur(e){
			let that = this
			console.log("失去焦点",e);
			that.s_page = 1
			that.s_adv_name = '' // 清空
			that.selectGgData = that.blurGgData 
		},
		
		// 腾讯广告账户下拉-开始
		// select选择器下拉加载更多功能实现
		popupScrollTxAcc(e){ // 上拉触底加载更多
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.t_loading_more_control){ // 节流，保证这期间只执行一次
					this.t_loading_more_hint = true
					this.t_loading_more_control = false
					let that = this
					that.t_page = that.t_page + 1
					console.log("上拉触底加载更多");
					MPggSelectAcc({
						page: that.t_page,
						limit: that.s_limit,
						account_name: that.t_account_name,
					}).then(res=>{
						console.log('选择',res);
						
						let data = that.selectTxGg 
						that.t_loading_more_hint = false
						that.selectTxGg = data.concat(res.data.data.data) 
						that.t_fetching = false
						that.t_loading_more_control = true
					})
				}
			}
		},
		// 选择框搜索-选择广告账户
		selectTxSearch(e){
			console.log("选择框搜索",e);
			let that = this
			that.selectTxGg = []
			that.t_fetching = true
			that.t_account_name = e
			
			MPggSelectAcc({
				page: 1,
				limit: that.s_limit,
				account_name: e,
			}).then(res=>{
				console.log('选择',res);
				that.t_page = 1
				that.selectTxGg = res.data.data.data
				that.t_fetching = false
			})
		},
		// 失去焦点
		txBlur(e){
			let that = this
			console.log("失去焦点",e);
			that.t_page = 1
			that.t_account_name = '' // 清空
			that.selectTxGg = that.blurTxGg 
		},
		// 腾讯广告账户下拉-结束
	},
	filters: {
		ptFilters(value){
			let vvv = ''
			if(value == 1){
				vvv = '巨量'
			}
			else if(value == 2){
				vvv = '腾讯'
			}
			else if(value == 3){
				vvv = '快手'
			}
			else if(value == 4){
				vvv = '百度'
			}
			else if(value == 5){
				vvv = '微博'
			}
			else {
				vvv = '其他'
			}
			return vvv
		}
	}
}	
</script>

<style scoped>
.table-td-cell{
	font-size: 13px;
}
</style>